import styled from "@emotion/styled";

const FPButton = ({
  background,
  children,
  fontSize,
  icon,
  onClick,
  outlined = true,
  textColor,
  padding,
  theme = "light", // 'light' or 'dark'
  width = "10rem",
  ...rest
}) => {
  return (
    <Button
      onClick={(e) => onClick?.(e)}
      themeStyle={theme}
      background={background}
      fontSize={fontSize}
      textColor={textColor}
      outlined={outlined}
      padding={padding}
      width={width}
      {...rest}
    >
      {icon && (
        <Icon data-feather={icon} themeStyle={theme} textColor={textColor} />
      )}
      {children}
    </Button>
  );
};

export default FPButton;

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 0.5rem;
  border-radius: 50px;
  padding: ${({ padding }) => padding || "6px"};
  font-weight: 700;
  cursor: pointer;
  width: 100%;
  transition: all 0.15s ease-in-out;
  font-size: ${({ fontSize }) => fontSize || "0.9rem"};
  position: relative;
  overflow: hidden;

  ${({ background, themeStyle, $dark, textColor }) =>
    background
      ? `background: ${background}; color: ${textColor || (themeStyle === "dark" ? "white" : "black")};`
      : $dark
        ? `background-color: black; color: ${textColor || "white"};`
        : textColor
          ? `color: ${textColor};`
          : ""}

  ${({ background, themeStyle, $dark, textColor }) =>
    background
      ? `background: ${background}; color: ${textColor || (themeStyle === "dark" ? "white" : "black")};`
      : $dark
      ? `background-color: black; color: ${textColor || "white"}; &:not(:disabled):hover { background-color: rgba(0,0,0,0.8); }`
      : textColor
      ? `color: ${textColor};`
      : ""}

  border: ${({ outlined, themeStyle }) =>
    outlined
      ? `1px solid ${themeStyle === "dark" ? "white" : "black"}`
      : "1px solid transparent"};

  &:not(:disabled) {
    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

      ${({ background, $dark }) => {
    if (background === "#3b72fe" || background?.includes("72fe")) {
      return `background: #2563eb;`;
    }
    if ($dark || background === "black") {
      return `background-color: #333;`;
    }
    return `filter: brightness(0.95);`;
  }}
    }

    &:active {
      transform: translateY(0px);
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);

      ${({ background, $dark }) => {
    if (background === "#3b72fe" || background?.includes("72fe")) {
      return `background: #1d4ed8;`;
    }
    if ($dark || background === "black") {
      return `background-color: #1a1a1a;`;
    }
    return `filter: brightness(0.9);`;
  }}
    }
  }


  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;

const Icon = styled.i`
  width: 16px;
  height: 16px;
  color: ${({ textColor, themeStyle }) =>
    textColor || (themeStyle === "dark" ? "white" : "black")};
`;
